import type { FaireProductEntity } from "../../entity_types/product";

export const p_txa67w54ef: FaireProductEntity = {
  token: "p_txa67w54ef",
  type: "product",
  name: "Pink Petals Bridal Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ade2003111d99b7433f90eb2046157f306fdc210e08353b16626f1e1ee4d3706.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9d19e8580a8236d3e2e61b5f045a7c1c5e9fe2f4e1a59e69614a574cae59064.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:11.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
